import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M8.10779 0.72343L4.63477 4.07797L1.16174 0.72343C0.887877 0.43173 0.614021 0.425653 0.340161 0.705198C0.0663005 0.984745 0.0663005 1.25821 0.340161 1.5256L4.22398 5.31769C4.32356 5.43923 4.46049 5.5 4.63477 5.5C4.80904 5.5 4.94597 5.43923 5.04555 5.31769L8.92937 1.5256C9.20323 1.25821 9.20323 0.984745 8.92937 0.705198C8.65551 0.425653 8.38165 0.43173 8.10779 0.72343Z",
      fill: "#999999"
    }, null, -1)
  ])))
}